<template>
  <div id="post-site-image-single">
    <div class="card" :class="{'card-inactive': isDisable()}">
      <div class="card-header">
        <h3 class="card-title title">Картинка</h3>
        <template v-if="hasImage()">
          <div class="card-actions">
            <svg @click="onDeleteImage()" xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M18 6l-12 12"></path>
              <path d="M6 6l12 12"></path>
            </svg>
          </div>
        </template>
      </div>
      <div class="card-body">
        <template v-if="!hasImage()">
          <div class="fallback">
            <input type="file" @change="onImageChange"/>
          </div>
        </template>
        <template v-if="hasImage()">
          <template v-if="isUploadIMage()">
            <div class="spinner-border spinner-border-sm me-2"></div>
          </template>
          <template v-else>
            <template v-if="isCropMode()">
              <Cropper
                class="cropper"
                :src="getOriginImage()"
                :stencil-props="{
                  aspectRatio: 1,
                }"
                :min-width="500"
                :min-height="500"
                :resize-image="true"
                @change="changeCrop"
              ></Cropper>
            </template>
            <template v-else>
              <Lightbox :images="{thumb: getImage(500), origin: getImage()}"></Lightbox>
            </template>
            <span class="row">
              <span class="col">
                <span class="col-6">
                  <div class="crop-image mt-2 d-flex justify-content-center">
                    <template v-if="isCropMode()">
                      <button @click="applyCrop()" class="btn btn-green btn-icon me-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M5 12l5 5l10 -10" />
                        </svg>
                      </button>
                      <button @click="toggleCropMode()" class="btn btn-danger btn-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon icon-tabler icons-tabler-filled icon-tabler-circle-x">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z" />
                        </svg>
                      </button>
                    </template>
                    <template v-else>
                      <button @click="toggleCropMode()" class="btn btn-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                          <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                          <path d="M9.15 14.85l8.85 -10.85" />
                          <path d="M6 4l8.85 10.85" />
                        </svg>
                        Обрезать до квадрата
                      </button>
                    </template>
                  </div>
                </span>
              </span>
            </span>
          </template>
        </template>
        <template v-if="isLoadImage()">
          <div class="mt-3">
            <div class="progress progress-sm">
              <div class="progress-bar progress-bar-indeterminate"></div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import Api from "./services/Api"
import {defineComponent, reactive, ref, watch, toRaw} from "vue"
import Lightbox from "@/components/lightbox/Lightbox"
import Image from "@/services/Image"
import Notify from "@/services/Notify"
import Cropper from "@/plugins/cropper"
import Helper from "@/services/Helper";

export default defineComponent({
  name: "SiteImageSingle",
  components: {
    Lightbox,
    Cropper,
  },
  props: {
    postId: {
      type: Number,
    },
    src: {
      type: Object,
    },
  },
  setup(props, {emit}) {
    let postId = ref(props.postId)
    let image = ref(props.src)
    let loadImage = ref(false)
    let cropMode = ref(false)
    let coords = reactive({
      width: 0,
      height: 0,
      left: 0,
      top: 0,
    })
    let uploadImage = ref(false)

    watch(() => props.postId, (val) => {
      postId.value = val
    })

    function toggleCropMode() {
      cropMode.value = !cropMode.value
    }

    function isCropMode() {
      return cropMode.value === true
    }

    function deactiveCropMode() {
      cropMode.value = false
    }

    function isActive() {
      return hasPostId()
    }

    function hasPostId() {
      return postId.value !== null
    }

    function hasImage() {
      return image.value !== null
    }

    function deleteImage() {
      deleteImageApi(getPayload({
        post_id: postId.value,
        image_id: image.value["id"],
      })).then(() => {
        return image.value = null
      })
    }

    function onDeleteImage() {
      if (confirm("Вы действительно хотите удалить картинку?")) {

        deleteImage()

        emit("onDelete")
      }
    }

    function isLoadImage() {
      return loadImage.value === true
    }

    function getImage(w = null, h = null) {
      return [
        Image.handle(image.value["host"], image.value["name"], w, h)
      ]
    }

    function getOriginImage(w = null, h = null) {
      return [
        Image.handle(image.value["host"], image.value["name"], w, h, true)
      ]
    }

    function onImageChange(e) {
      change(e)
    }

    function change(e) {
      loadImage.value = true

      if (e.target.files[0].size > 5242880) {
        Notify.error("Размер картинки не должен превышать 5мб");
        loadImage.value = false
        return;
      }

      uploadImageApi(getPayload({
        post_id: postId.value,
        image: e.target.files[0],
      })).then((resp) => {
        setImage({
          "host": resp["host"],
          "name": resp["name"],
          "id": resp["image_id"],
        })

        emit("onChange", {
          host: resp["host"],
          name: resp["name"],
        })
      }).finally(() => {
        loadImage.value = false
      })
    }

    function setImage(val) {
      image.value = val
    }

    function uploadImageApi(payload) {
      return Api.addImage(payload)
    }

    function deleteImageApi(payload) {
      return Api.deleteImage(payload)
    }

    function cropImage(payload) {
      return Api.crop(payload)
    }

    function getPayload(obj) {
      const formData = new FormData()

      Object.entries(obj).forEach(([key, val]) => {
        formData.append(key, val)
      })

      return formData
    }

    function isDisable() {
      return !isActive() && !hasImage()
    }

    function changeCrop({coordinates}) {
      coords.width = coordinates["width"];
      coords.height = coordinates["height"];
      coords.left = coordinates["left"];
      coords.top = coordinates["top"];
    }

    function onUploadImage() {
      uploadImage.value = true
    }

    function offUploadImage() {
      uploadImage.value = false
    }

    function isUploadIMage() {
      return uploadImage.value === true
    }

    function applyCrop() {
      let data = toRaw(coords)
      let imageName = image.value["name"]

      deactiveCropMode();
      onUploadImage()

      cropImage(getPayload({
        post_id: postId.value,
        name: imageName,
        width: data.width,
        height: data.height,
        left: data.left,
        top: data.top,
      })).then((resp) => {
        let item = resp.data?.item

        if (Helper.isEmpty(item)) {
          throw Error("Отсутствуют данные от кроппера")
        }

        let host = item.host
        let name = item.name
        let fileId = item.file_id

        setImage({
          "host": host,
          "name": name,
          "id": fileId,
        })

        offUploadImage()
        Notify.success("Обрезано до квадрата")
      })
    }

    return {
      isActive,
      hasImage,
      onDeleteImage,
      isLoadImage,
      getImage,
      onImageChange,
      isDisable,
      changeCrop,
      toggleCropMode,
      isCropMode,
      applyCrop,
      isUploadIMage,
      getOriginImage,
    }
  }
})
</script>

<style scoped></style>
